export default {
  SET_WIDTH: 'setWidth',
  SET_CONTENT_MODULE: 'setContentModule',
};
